(function () {
  // Mapa pais (ISO 3166-1 alpha-2, lo que entrega localization.country) -> moneda local
  var CURRENCY_MAP = {
    CL: 'CLP',
    AR: 'ARS',
    MX: 'MXN',
    CO: 'COP',
    PE: 'PEN',
    UY: 'UYU',
    BO: 'BOB',
    PY: 'PYG',
    VE: 'VES',
    GT: 'GTQ',
    CR: 'CRC',
    PA: 'PAB',
    DO: 'DOP',
    HN: 'HNL',
    SV: 'USD',
    NI: 'NIO',
    EC: 'USD',
    ES: 'EUR',
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    PT: 'EUR',
    NL: 'EUR',
    GB: 'GBP',
    CA: 'CAD',
    AU: 'AUD',
  };

  var FX_CACHE_KEY = 'prendelax_fx_usd';
  var FX_CACHE_HOURS = 6;

  function getCountry() {
    return (document.body && document.body.getAttribute('data-visitor-country')) || '';
  }

  function getCurrency(country) {
    return CURRENCY_MAP[country] || null;
  }

  function getCachedRates() {
    try {
      var raw = sessionStorage.getItem(FX_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      var ageHours = (Date.now() - parsed.ts) / (1000 * 60 * 60);
      if (ageHours > FX_CACHE_HOURS) return null;
      return parsed.rates;
    } catch (e) {
      return null;
    }
  }

  function setCachedRates(rates) {
    try {
      sessionStorage.setItem(FX_CACHE_KEY, JSON.stringify({ ts: Date.now(), rates: rates }));
    } catch (e) {}
  }

  function fetchRates() {
    var cached = getCachedRates();
    if (cached) return Promise.resolve(cached);

    return fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (res) {
        if (!res.ok) throw new Error('fx fetch failed');
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.rates) throw new Error('fx bad payload');
        setCachedRates(data.rates);
        return data.rates;
      });
  }

  function formatAmount(amount, currency) {
    try {
      return new Intl.NumberFormat('es', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return '~' + Math.round(amount) + ' ' + currency;
    }
  }

  function renderReferences(rate, currency) {
    var nodes = document.querySelectorAll('.local-price-ref[data-usd]');
    nodes.forEach(function (node) {
      var usd = parseFloat(node.getAttribute('data-usd'));
      if (!usd || usd <= 0) return;
      var converted = usd * rate;
      node.textContent = '≈ ' + formatAmount(converted, currency) + ' (referencial)';
      node.hidden = false;
    });
  }

  function init() {
    var country = getCountry();
    if (!country) return;

    var currency = getCurrency(country);
    if (!currency || currency === 'USD') return;

    fetchRates()
      .then(function (rates) {
        var rate = rates[currency];
        if (!rate) return;
        renderReferences(rate, currency);
      })
      .catch(function () {
        // Silencioso: si falla la conversion, simplemente no se muestra el precio de referencia
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
